/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeNew from './envelope-new-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeNew {...validProps} />;
}
SvgComponent.iconName = 'envelopeNewIcon';

export const EnvelopeNewIcon = svgIconWrapper(SvgComponent);
